var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4769 46.6667H35.5032M35.5003 37.9167V26.25M16.0228 28.2421C23.0607 15.785 26.5811 9.55794 31.4111 7.95378C34.066 7.07246 36.9346 7.07246 39.5894 7.95378C44.4194 9.55794 47.9399 15.785 54.9778 28.2421C62.0186 40.6963 65.5361 46.9263 64.4832 52.0013C63.8999 54.7954 62.4707 57.3271 60.394 59.2346C56.6199 62.7084 49.579 62.7084 35.5003 62.7084C21.4215 62.7084 14.3807 62.7084 10.6065 59.2375C8.52182 57.3124 7.09192 54.7831 6.51736 52.0042C5.46153 46.9292 8.98195 40.6992 16.0228 28.2421Z",
    stroke: "#0169EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d31a45f23d5235241ec158b0a9a96231.svg";
export { ForwardRef as ReactComponent };